import React, {Component} from 'react';
import {Table} from 'reactstrap';
import {toast} from 'react-toastify';
import NumberFormat from 'react-number-format';
import moment from 'moment';
import DatePicker from 'react-datepicker';

import {getPermission, getUser} from '../../utils/TokenManager';
import ErrorMsg from "../common/ErrorMsg";
import {downloadPDF, KPI_REPORT} from "../common/Constants";
import loadingGIF from "../../public/assets/images/loading.gif";


const MAX_NO_OF_DEPTS = 5

export default class KPIReport extends Component {
    
    state = {
        startDate: moment(),
        endDate: moment(),
        kpiReportData: {},
        departmentList: [],
        isLoading: false,
        showGIF: false,
        totalLocation: 1,
        // kpi available in select box to select
        selectableDeptList: [],
        // previously saved selected department list object
        selectedDeptObj: {},
        // kpi list which are currently shown
        selectedDepts: [],
        showGoal: true
    };

    auth = {
		user: getUser(),
		permission: getPermission()[KPI_REPORT]
	}

    componentDidMount = () => {
        if (this.props.agencyLocation) {
            this.getLocationCount();
            this.getSelectedDepartments();
            this.getDepartmentList();
        }
    };

    getLocationCount = async () => {
        try {
            let result = await this.props.getLocationCount();
            if (result) {
                let totalLocation = result.count;
                this.setState({totalLocation});
            }
        } catch (error) {
            toast.error(<ErrorMsg errors={error}/>);
        }
    }

    getDates = () => {
        const {startDate, endDate} = this.state;
        let reqStartDate = moment(startDate);
        let reqEndDate = moment(endDate);
        if (!startDate || startDate  === "Invalid date") {
            if (!endDate || endDate  === "Invalid date") {
                reqStartDate = moment();
            } else {
                reqStartDate = moment(endDate);
            }
        } 
        if (!endDate || endDate  === "Invalid date") {
            if (!startDate || startDate  === "Invalid date") {
                reqEndDate = moment();
            } else {
                reqEndDate = moment(startDate);
            }
        }
        reqStartDate = moment(reqStartDate).format("YYYY-MM-DD");
        reqEndDate = moment(reqEndDate).format("YYYY-MM-DD");

        return {startDate: reqStartDate, endDate: reqEndDate};
    }

    getKPIReportData = async () => {
        if (this.auth.permission.can_view) {
            this.setState({isLoading: true});
            const {agencyLocation} = this.props;
            try {
                const {startDate, endDate} = this.getDates();
                let result = await this.props.getKPIReport(
                    agencyLocation, startDate, endDate
                );
                if (result) {
                    let kpiReportData = {...result};
                    this.setState({kpiReportData});
                }
            } catch (error) {
                toast.error(<ErrorMsg errors={error}/>);
            }
            this.setState({isLoading: false});
        }
    }

    getDepartmentList = async () => {
        if (this.auth.permission.can_view) {
            this.setState({isLoading: true});
            const {agencyLocation} = this.props;
            try {
                let result = await this.props.getDepartmentList(agencyLocation);
                if (result) {
                    let departmentList = [...result];
                    this.setState({departmentList}, () => this.updateSelctedDepts());
                }
            } catch (error) {
                toast.error(<ErrorMsg errors={error} />);
            }
            this.setState({isLoading: false});
        }
    }

    getSelectedDepartments = async () => {
        if (this.auth.permission.can_view) {
            const {agencyLocation} = this.props;
            try {
                let result = await this.props.selectedDeptList(agencyLocation, {}, "GET");
                if (result) {
                    let selectedDeptObj = {...result};
                    
                    let startDate = selectedDeptObj.start_date ? 
                        moment(selectedDeptObj.start_date) : null;
                    let endDate = selectedDeptObj.end_date ? 
                        moment(selectedDeptObj.end_date) : null;
                    
                    this.setState({
                        selectedDeptObj, startDate, endDate,
                        showGoal: selectedDeptObj.show_goal
                    }, () => {
                        this.getKPIReportData();
                        this.updateSelctedDepts();
                    });
                }
            } catch (error) {
                toast.error(<ErrorMsg errors={error}/>);
            }
        }
    }

    updateSelctedDepts = () => {
        const {selectedDeptObj} = this.state;
        let selectedDeptList = selectedDeptObj.department_list || [];
        let departmentList = this.state.departmentList.map(dept => ({...dept}));
        
        let selectedDepts = [];
        selectedDeptList.map(deptId => {
            for (let index in departmentList) {
                if (departmentList[index].id === deptId && !(departmentList[index]['selected'])) {
                    selectedDepts.push({...departmentList[index]});
                    departmentList[index]['selected'] = true;
                }
            }
        });
        
        let noOfSelectedDept = selectedDepts.length;
        let noOfRemainingDept = MAX_NO_OF_DEPTS - noOfSelectedDept;
        let i = 0;
        for (let index in departmentList) {
            if (i >= noOfRemainingDept) {
                break;
            }
            if (!(departmentList[index]['selected'])) {
                selectedDepts.push({...departmentList[index]});
                departmentList[index]['selected'] = true;
                i++;
            }
        }

        this.setState({selectedDepts}, () => {
            this.getDeptListExceptSelected();
        });
    }

    getDeptListExceptSelected = () => {
        let {selectedDepts, departmentList} = this.state;
        let selectedDeptId = selectedDepts.map(dept => dept.id);
        let newDeptList = departmentList.filter(dept => {
            if (!(selectedDeptId.includes(dept.id))) {
                return {...dept};
            }
        });
        this.setState({selectableDeptList: newDeptList});
    }

    handleDateChange = (date, field) => {
        if (field === "startDate") {
            let startDate = moment(date);
            let {endDate} = this.state;
            let minDate = moment(startDate);
            if (!(endDate >= minDate)) {
                this.setState({endDate: minDate});
            }
            this.setState({startDate: date});
        } else {
            this.setState({endDate: date});
        } 
    };

    handleDateChangeRaw = (event) => {
        event.preventDefault();
    };

    handleSelectDept = (e, deptId) => {
        // deptId = prev dept id to be replaced
        // value = new dept id selected
        let value = parseInt(e.target.value);
        let selectedDept;
        this.state.selectableDeptList.map(dept => {
            if(dept.id === value) {
                selectedDept = {...dept};
            }
        });
        let selectedDepts = this.state.selectedDepts.map(dept => {
            if (deptId === dept.id) {
                return {...selectedDept};
            }
            return {...dept};
        });
        this.setState({selectedDepts}, () => {
            this.getDeptListExceptSelected();
            this.saveSelection();
        });

    }

    saveSelection = async () => {
        if (this.auth.permission.can_edit) {
            try {
                const {agencyLocation} = this.props;
                let {selectedDepts, showGoal} = this.state;
                if (selectedDepts.length) {
                    let selectedDeptId = selectedDepts.map(dept => dept.id);
                    const {startDate, endDate} = this.getDates();
                    let selectedDeptObj = {
                        agency_location: agencyLocation,
                        department_list: selectedDeptId,
                        start_date: startDate, end_date: endDate,
                        show_goal: showGoal
                    }
                    await this.props.selectedDeptList(agencyLocation, selectedDeptObj, "PUT");
                }
            } catch (error) {
                console.log("In Unmount: ", error);
            }
        }
    }

    handleShowGoalChange = () => {
        this.setState(
            prevState => ({showGoal: !prevState.showGoal}),
            () => this.saveSelection()
        );
    }

    submitDates = () => {
        this.saveSelection();
        this.getKPIReportData();
    }

    componentWillUnmount = async () => {
        await this.saveSelection();
    }

    // Compare KPI for sorting
    compareKPI = (a, b) => {
        if (a.name.toUpperCase() < b.name.toUpperCase()) {
            return -1;
        }
        if (a.name.toUpperCase() > b.name.toUpperCase()) {
            return 1;
        }
        return 0;
    };

    renderHeadings = () => {
        const {selectableDeptList, selectedDepts, totalLocation, showGoal} = this.state;
        let deptOptions = selectableDeptList.map((dept, index) => 
            <option key={index} value={dept.id}>{dept.name}</option>
        );
        let headings = [
            <th key={-2} rowSpan={2} className="font-weight-bold staff-td-width">
                KPI
            </th>,
            <th key={-1} colSpan={showGoal ? 2 : 1} className="agency-column font-weight-bold">
                {totalLocation > 1 ? "Current Location": "Agency"}
            </th>
        ];
        selectedDepts.map((dept, index) => {
            headings.push(
                <th colSpan={showGoal ? 2 : 1} className="daily-activity-th" key={index}>
                    {dept.name}
                    {deptOptions.length ?
                        <select name="department" className="daily-activity-select" 
                            onChange={(e) => this.handleSelectDept(e, dept.id)} 
                            value={dept.id}
                        >
                            <option value={dept.id} disabled>-------Select-------</option>
                            {deptOptions}
                        </select>
                        : null
                    }
                </th>
            );
        });

        return headings;
    }

    renderKPIandData = () => {
        const {kpiReportData} = this.state;
        let kpiList = [];
        let agencydata = {};
        Object.keys(kpiReportData).map(deptKPI => {
            let kpiId = deptKPI.split('_')[1];
            if (agencydata[kpiId]) {
                if (kpiReportData[deptKPI].kpi_formula === "Use") {
                    agencydata[kpiId] = {
                        goal: kpiReportData[deptKPI].goal,
                        actual: kpiReportData[deptKPI].actual
                    }
                } else {
                    agencydata[kpiId] = {
                        goal: agencydata[kpiId].goal + kpiReportData[deptKPI].goal,
                        actual: agencydata[kpiId].actual + kpiReportData[deptKPI].actual
                    }
                }
            } else{
                agencydata[kpiId] = {
                    goal: kpiReportData[deptKPI].goal,
                    actual: kpiReportData[deptKPI].actual
                }
                kpiList.push({
                    id: kpiId,
                    name: kpiReportData[deptKPI].kpi_name,
                    data_type: kpiReportData[deptKPI].kpi_data_type,
                    formula: kpiReportData[deptKPI].kpi_formula
                });
            }
        });
        kpiList.sort(this.compareKPI);
        return {agencydata: agencydata, kpiList: kpiList};
    }

    generatePDF = async() => {
        if (this.auth.permission.can_view) {
            const {selectedDepts, kpiReportData, showGoal} = this.state;
            const {agencydata, kpiList} = this.renderKPIandData();
            const {startDate, endDate} = this.getDates();
            this.setState({isLoading: true});
            try {
                let data = {
                    kpi_list: kpiList,
                    department_list: selectedDepts,
                    agency_data: agencydata,
                    department_data: kpiReportData,
                    start_date: startDate,
                    end_date: endDate,
                    show_goal: showGoal
                }

                let result = await this.props.generateKPIReport(
                    this.props.agencyLocation, data
                );
                
                if (result) {
                    let content = result.content;
                    let fileName = result.file_name;
                    downloadPDF(content, fileName);
                }
            } catch (error) {
                toast.error(<ErrorMsg errors={error}/>);
            }
            this.setState({isLoading: false});
        }
    }

    render() {
        const {
            startDate, endDate, isLoading, showGIF, selectedDepts, kpiReportData, showGoal
        } = this.state; 

        let data = this.renderKPIandData();
        let rows = [];

        data.kpiList.map((kpi, index) => {
            let agencyGoal = '', agencyActual = '';
            if (kpi.data_type === "Currency") {
                agencyGoal = <NumberFormat 
                    value={data.agencydata[kpi.id].goal} 
                    displayType={'text'} thousandSeparator={true} 
                    decimalScale={2} prefix={'$'} 
                />
                agencyActual = <NumberFormat 
                    value={data.agencydata[kpi.id].actual} 
                    displayType={'text'} thousandSeparator={true} 
                    decimalScale={2} prefix={'$'} 
                />
            } else if (kpi.data_type === "Percentage") {
                agencyGoal = <NumberFormat 
                    value={data.agencydata[kpi.id].goal} 
                    displayType={'text'} thousandSeparator={true} 
                    decimalScale={2} suffix={'%'} 
                />
                agencyActual = <NumberFormat 
                    value={data.agencydata[kpi.id].actual} 
                    displayType={'text'} thousandSeparator={true} 
                    decimalScale={2} suffix={'%'} 
                />
            } else {
                agencyGoal = <NumberFormat key={index} 
                    value={data.agencydata[kpi.id].goal} displayType={'text'} 
                    thousandSeparator={true} decimalScale={0} 
                />
                agencyActual = <NumberFormat key={index} 
                    value={data.agencydata[kpi.id].actual} displayType={'text'} 
                    thousandSeparator={true} decimalScale={0} 
                />
            }
            let cols = [
                <td key={'kpi' + index}>{kpi.name}</td>
            ]
            if (showGoal) {
                cols.push(
                    <td key={'aGoal' + index} className="agency-column">
                        {agencyGoal}
                    </td>
                );
            }
            cols.push(
                <td key={'aActual' + index} className="agency-column">
                    {agencyActual}
                </td>
            );
            selectedDepts.map((dept, ind) => {
                let key = dept.id + "_" + kpi.id;
                let formattedGoal = '', formattedActual = '';
                let goal = key in kpiReportData ? kpiReportData[key].goal : '';
                let actual = key in kpiReportData ? kpiReportData[key].actual : '';
                if (kpi.data_type === "Currency") {
                    formattedGoal = <NumberFormat key={index} 
                        value={goal} displayType={'text'} 
                        thousandSeparator={true} 
                        decimalScale={2} prefix={'$'} 
                    />;
                    formattedActual = <NumberFormat key={index} 
                        value={actual} displayType={'text'} 
                        thousandSeparator={true} 
                        decimalScale={2} prefix={'$'} 
                    />;
                } else if (kpi.data_type === "Percentage") {
                    formattedGoal = <NumberFormat key={index} 
                        value={goal} 
                        displayType={'text'} thousandSeparator={true} 
                        decimalScale={2} suffix={'%'} 
                    />;
                    formattedActual = <NumberFormat key={index} 
                        value={actual} 
                        displayType={'text'} thousandSeparator={true} 
                        decimalScale={2} suffix={'%'} 
                    />;
                } else {
                    formattedGoal = <NumberFormat key={index} 
                        value={goal} displayType={'text'} 
                        thousandSeparator={true} decimalScale={0} 
                    />;
                    formattedActual = <NumberFormat key={index} 
                        value={actual} displayType={'text'} 
                        thousandSeparator={true} decimalScale={0} 
                    />;
                }
                if (showGoal) {
                    cols.push(
                        <td className="text-center align-middle" key={'g' + key + ind}>
                            {formattedGoal}
                        </td>
                    );
                }
                cols.push(
                    <td className="text-center align-middle text-success" key={'a' + key + ind}>
                        {formattedActual}
                    </td>
                );
            });
            rows.push(<tr key={index}>{cols}</tr>);
        });

        let th2List = [];
        selectedDepts.map(dept => {
            if (showGoal) {
                th2List.push(<th key={'g' + dept.id} className="text-center">Goal</th>);
            }
            th2List.push(<th key={'a' + dept.id} className="text-center">Actual</th>);
        })

        return (
            this.auth.permission.can_view ?
                <div className="tab-pane" role="tabpanel">
                    <div className="row mb-1">
                        <div className="col-md-7">
                            <div className="d-flex align-items-center">
                                <label className="mb-0 pr-2">Start Date: </label>
                                <div className="div-datepicker pr-3">
                                    <DatePicker
                                        selected={startDate} 
                                        onChangeRaw={this.handleDateChangeRaw}
                                        onChange={(e) => this.handleDateChange(e, "startDate")}
                                        dateFormat="MM/DD/YYYY" fixedHeight
                                        showMonthDropdown showYearDropdown
                                        dropdownMode="select" 
                                        className="form-control form-control-sm"
                                        placeholderText="Start date"
                                        minDate={moment('2012-01-01')}
                                        maxDate={moment().add(5, 'years')}
                                        autoComplete="off" list="autocompleteOff" 
                                    />
                                </div>
                                <label className="mb-0 pr-2">End Date:</label>
                                <div className="div-datepicker pr-3">
                                    <DatePicker
                                        selected={endDate} 
                                        onChangeRaw={this.handleDateChangeRaw}
                                        onChange={(e) => this.handleDateChange(e, "endDate")}
                                        fixedHeight dateFormat="MM/DD/YYYY"
                                        showMonthDropdown showYearDropdown
                                        dropdownMode="select" className="form-control form-control-sm"
                                        placeholderText="End date"
                                        minDate={moment(startDate)}
                                        autoComplete="off" list="autocompleteOff" 
                                    />
                                </div>
                                <button className="btn btn-success btn-sm" 
                                    onClick={this.submitDates}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                        <div className="col-md-2" style={{paddingTop: "6px"}}>
                            <div className="form-check">
                                <label className="form-check-label position-relative">
                                    <input className="form-check-input my-0" type="checkbox"
                                        checked={showGoal}
                                        value={showGoal}
                                        name="show_goal"
                                        onChange={this.handleShowGoalChange}
                                    />
                                    &nbsp; Show Goal
                                </label>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <ul className="secondary-menu">
                                <li onClick={this.getKPIReportData} 
                                    title="Reload list" className="float-md-right pt-1"
                                >
                                    <a className="text-info pr-0"> 
                                        <span className="fa fa-refresh"></span>
                                    </a>
                                </li>
                                {this.auth.permission.can_view &&
                                    <li onClick={this.generatePDF} className="float-right pt-1">
                                        <a className="text-info pr-3 mr-0" disabled={isLoading}> 
                                            Print Report
                                        </a>
                                    </li>
                                }
                                {isLoading && 
                                    <li>
                                        <img src={loadingGIF} width="32" height="32" />
                                    </li>
                                }
                            </ul>
                        </div>
                    </div>
                    <Table responsive striped bordered size="sm" className="mb-0">
                        <thead className="bg-light">
                            <tr>{this.renderHeadings()}</tr>
                            <tr className="bg-warning">
                                {showGoal ?
                                    <th className="agency-column font-weight-bold">Goal</th>
                                    : null
                                }
                                <th className="agency-column font-weight-bold">Actual</th>
                                {th2List}
                            </tr>
                        </thead>
                        <tbody>
                            {
                                rows.length > 0 ? 
                                    rows 
                                : showGIF && <p className="text-center">
                                    <img src={loadingGIF} alt="loading" width="32" height="32" />
                                </p>
                            }
                        </tbody>
                    </Table>
                </div>
            : <div className="tab-pane text-center" role="tabpanel">
                Access Denied
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/agencyKPIReport/KPIReport.js